/*
 * correct/incorrect flag
 */
import { Themed } from 'interfaces/mixins';
import { theme } from '@dojo/framework/core/mixins/Themed';
import { v } from '@dojo/framework/core/vdom';
import { DNode } from '@dojo/framework/core/interfaces';

import css from '../css/correct.m.css';

export interface CorrectProperties {
	title: string;
	iscorrect: boolean;
}

@theme(css)
export class Correct extends Themed<CorrectProperties> {
	protected render(): DNode {
		const { key = 'passfail', title, iscorrect } = this.properties;
		const titleId = `${key}TitleId`;
		const ariaTitle = `${title}`;

		return v('div', { key, classes: [this.theme(css.root)] }, [
			v('svg', { viewBox: `0 0 70 24`, role: 'img', 'aria-labelledby': titleId }, [
				v('title', { key: '0', id: titleId }, [ariaTitle]),
				v('rect', {
					width: '64',
					height: '18',
					classes: [this.theme(css.rect), iscorrect ? this.theme(css.correct) : this.theme(css.incorrect)],
					key: '2'
				}),
				v('text', { key: '1', x: '38', classes: [this.theme(css.title)] }, [title])
			])
		]);
	}
}

export default Correct;
